import React, { useEffect, useState } from 'react';
import { FaRegSave, FaTimes } from 'react-icons/fa';

const TipoAcessoModal = ({ tipo, onClose, onSave }) => {
  const [nome, setNome] = useState('');
  const [apareceNaAgenda, setApareceNaAgenda] = useState(false);
  const [titulo, setTitulo] = useState('');

  useEffect(() => {
    if (tipo) {
      setNome(tipo.nome || '');
      setApareceNaAgenda(!!tipo.aparece_na_agenda);
      setTitulo('Editar Tipo de Acesso');
    } else {
      setNome('');
      setApareceNaAgenda(false);
      setTitulo('Novo Tipo de Acesso');
    }
  }, [tipo]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (nome.trim()) {
      onSave({ nome: nome.trim(), aparece_na_agenda: apareceNaAgenda });
    }
  };

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h4 className="fw-bold mt-2">{titulo}</h4>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <label className="form-label fw-bold">Nome</label>
                  <input
                    type="text"
                    className="form-control"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    autoComplete="off"
                    maxLength={100}
                    required
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="aparece_na_agenda"
                      checked={apareceNaAgenda}
                      onChange={(e) => setApareceNaAgenda(e.target.checked)}
                    />
                    <label className="form-check-label fw-bold" htmlFor="aparece_na_agenda">
                      Aparece na agenda
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer mt-4">
              <div className="row">
                <div className="col-12 text-end">
                  <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                    <FaTimes /> Fechar
                  </button>
                  <button className="btn btn-custom-primary ms-3" type="submit">
                    <FaRegSave /> Salvar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TipoAcessoModal;


